import { computed, defineComponent } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import Image from '@hems/component/src/image/Image.vue';
import { useLoading } from '@hems/util/src/composable/loading';
import { MOBILE_MODAL_TYPE } from '@hems/util/src/constant/modal';
export default defineComponent({
    name: 'MobileModal',
    components: { VueFinalModal, Image },
    props: {
        type: {
            type: String,
            default: MOBILE_MODAL_TYPE.ALERT,
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
        confirmButtonText: {
            type: String,
            default: '',
        },
        cancelButtonText: {
            type: String,
            default: '',
        },
    },
    emits: ['confirm', 'close'],
    setup(props, { emit }) {
        const { resetLoading } = useLoading();
        resetLoading();
        const onClose = (close) => {
            emit('close');
            close();
        };
        const onConfirm = (close) => {
            emit('confirm');
            close();
        };
        const setupAutoClose = (close) => {
            if (props.type === MOBILE_MODAL_TYPE.ALERT) {
                setTimeout(() => {
                    onClose(close);
                }, 1000);
            }
            return true;
        };
        const isAlertModal = computed(() => props.type === MOBILE_MODAL_TYPE.ALERT);
        const isWarningModal = computed(() => props.type === MOBILE_MODAL_TYPE.WARN);
        return {
            onClose,
            isAlertModal,
            setupAutoClose,
            onConfirm,
            isWarningModal,
            MOBILE_MODAL_TYPE,
        };
    },
});
